import type { ReactNode } from 'react';
import { Label } from '@/components/ui/label';

/** Étiquette + champ, sans wrapper `Form`/`FormField` : ces écrans recalculent en direct, sans cycle de soumission. */
export function Field({ label, htmlFor, children }: { label: string; htmlFor: string; children: ReactNode }) {
  return (
    <div className="flex flex-col gap-1.5">
      <Label htmlFor={htmlFor}>{label}</Label>
      {children}
    </div>
  );
}
